import { render, staticRenderFns } from "./ContactMailSection.vue?vue&type=template&id=2d7e6f1b&scoped=true&"
import script from "./ContactMailSection.vue?vue&type=script&lang=js&"
export * from "./ContactMailSection.vue?vue&type=script&lang=js&"
import style0 from "./ContactMailSection.vue?vue&type=style&index=0&id=2d7e6f1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7e6f1b",
  null
  
)

export default component.exports